// First-party cookie helpers for the cookie-consent banner. No external
// dependency — we read/write document.cookie directly.
//
// The visitor's choice ("granted" | "denied") is stored for 1 year. Until a
// choice exists (readConsent() === null), NO tracker is injected (opt-in, Loi 25).

export const CONSENT_COOKIE = "endorphine-cookie-consent"
export const CONSENT_GRANTED = "granted"
export const CONSENT_DENIED = "denied"

const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365

// Cookies set by the trackers we gate. On refusal we delete any that were
// already dropped (e.g. by a previous "accept" the visitor is now reversing).
// `_ga_*` is a per-property GA4 cookie, so we also sweep by prefix below.
const TRACKING_COOKIES = [
  "_ga",
  "_gid",
  "_gat",
  "_fbp",
  "hubspotutk",
  "__hstc",
  "__hssc",
  "__hssrc",
]
const TRACKING_COOKIE_PREFIXES = ["_ga_", "_gat_"]

const isBrowser = () => typeof document !== "undefined"

export const readConsent = () => {
  if (!isBrowser()) return null
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${CONSENT_COOKIE}=`))
  if (!match) return null
  const value = match.slice(CONSENT_COOKIE.length + 1)
  return value === CONSENT_GRANTED || value === CONSENT_DENIED ? value : null
}

export const writeConsent = (value) => {
  if (!isBrowser()) return
  // `Secure` only over HTTPS — omitted on http://localhost so the choice still
  // persists during `gatsby develop`. Netlify forces HTTPS in prod.
  const secure =
    typeof window !== "undefined" && window.location.protocol === "https:"
      ? "; Secure"
      : ""
  document.cookie = `${CONSENT_COOKIE}=${value}; Max-Age=${ONE_YEAR_SECONDS}; Path=/; SameSite=Lax${secure}`
}

// Delete a cookie by name across the domain variants a tracker might have used
// (host-only, current domain, and the apex `.endorphine.ca`).
const deleteCookie = (name) => {
  const expiry = "Max-Age=0; Path=/"
  const host = typeof window !== "undefined" ? window.location.hostname : ""
  const domains = [undefined, host, `.${host}`, ".endorphine.ca"]
  domains.forEach((domain) => {
    document.cookie = domain
      ? `${name}=; ${expiry}; Domain=${domain}`
      : `${name}=; ${expiry}`
  })
}

export const clearTrackingCookies = () => {
  if (!isBrowser()) return
  const names = new Set(TRACKING_COOKIES)
  // Sweep prefixed cookies (e.g. `_ga_ABC123`) actually present in the jar.
  document.cookie.split("; ").forEach((row) => {
    const name = row.split("=")[0]
    if (TRACKING_COOKIE_PREFIXES.some((prefix) => name.startsWith(prefix))) {
      names.add(name)
    }
  })
  names.forEach(deleteCookie)
}
